<!-- page-wrapper Start-->
<div
  [ngClass]="layout.config.settings.layout_type"
  [class]="layout.config.settings.layout_version"
>
  <div
    *ngIf ="!isLoading"
    class="page-wrapper"
    id="canvas-bookmark"
    [ngClass]="layout.config.settings.sidebar.type"
  >
    <div class="d-none d-md-none d-lg-block d-xl-block">
      <app-header></app-header>
    </div>
    <!-- Page Body Start-->
    <div
      class="page-body-wrapper"
      [ngClass]="layout.config.settings.sidebar.body_type"
    >
      <div class="sidebar-wrapper close_icon">
        <app-sidebar></app-sidebar>
      </div>
      <div class="page-body">
        <main [@fadeInAnimation]="getRouterOutletState(o)">
          <router-outlet #o="outlet"></router-outlet>
        </main>
      </div>
      <!-- footer start-->
      <footer class="footer d-none d-md-none d-lg-block d-xl-block">
        <app-footer></app-footer>
      </footer>
      <!-- footer End-->
    </div>
    <!-- Page Body End-->
  </div>
</div>
<!-- page-wrapper End-->
